export default __webpack_public_path__ + "static/certificate-marathon-vertical-f52389c0125c1f57e125953a0d6531e2.png";